import {find} from "lodash"

export default function(angularModule) {
  angularModule.controller('WidgetsCtrl',function($state, user, reviewGenService, pagingService, $uibModal, confirmService, userManagerService) {
    var vm = this;

    vm.widgetSearchQuery = null;
    vm.state = {
      loading: true
    };

    vm.widgetsPaged = {
      widgets: [],
      total: 0,
      pageSize: 15,
      currentPageNum: 1
    };

    vm.userMap = {};
    vm.refreshWidgets = function() {
      vm.state.loading = true;
      reviewGenService.searchWidgets(
        { searchTextOpt: vm.widgetSearchQuery,
          limitOpt: vm.widgetsPaged.pageSize,
          cursorOpt: (vm.widgetsPaged.currentPageNum - 1) * vm.widgetsPaged.pageSize}
      ).then(function(response) {
        vm.widgetsPaged.widgets = response.data.widgets;
        vm.widgetsPaged.total = response.data.count;
        vm.state.loading = false;

        if (user.permissions.indexOf("UserManagement") >= 0) {
          userManagerService.getUsers(vm.widgetsPaged.widgets.map(widget => widget.creatorId)).then(userMap => {
            vm.userMap = userMap
            vm.widgetsPaged.widgets.forEach(widget => {
              if (!vm.userMap[widget.creatorId]) { vm.userMap[widget.creatorId] = {firstName: "Account", lastName: "Admin"} }
            })
          });
        }

      });
    };

    vm.canModifyWidget = function(widget) {
      return _.includes(user.permissions, "UserManagement") || widget.creatorId ===  user.userId;
    }

    vm.refreshWidgets();

    vm.generateEmbedCode = function(widgetId) {
      $uibModal.open({
        controller: ["$scope",function($scope) {
          $scope.widgetId = widgetId;
          let widget = find(vm.widgetsPaged.widgets,{_id:widgetId})
          $scope.featureTags = widget.featureTags
        }],
        template: require('./widgetEmbedModal.html')  // this is an embedded template in widgets.html
      })
    };

    vm.deleteWidget = function(widgetToDelete) {
      confirmService.confirm('Delete Widget', `Are you sure you want to delete the widget, "${widgetToDelete.name}"?`, confirmService.DELETE)
        .then(response => {
          if (response) {
            reviewGenService.deleteWidget(widgetToDelete).then(vm.refreshWidgets)
          }
        })
    }
  });
};
